import BaseObject from '../../../../base/base_object';
import _ from "../../../../utils/underscore";
import Device from "../../../../utils/device/device";
import {FEATURE_CB_FUNC, KEY_NAME, SERIVCES_FUNC_LIST} from "../../native/native_const";
import {NATIVE_LOGS} from "../native_logs/native_logs_hybrid_consts";




/**
 *
 *
 */
class NativeLogs extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'NativeLogs';
    _HybridService = null;


    init(params) {

        super.init();

        if(_.isNullOrUndefined(params)){
            return;
        }
        if (Device.hybrid.isHybrid) {
            if (Device.os.isIOS) {
                params = params.ios;
            } else if (Device.os.isAndroid) {
                params = params.android;
            }
        }

        if(!_.isNullOrUndefined(params) && params.enable){
            this._bEnable = true;
        }
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        if(this._bEnable) {
            hybridSrv.setCbFunction(SERIVCES_FUNC_LIST.NATIVE_LOGS_SET_CB, FEATURE_CB_FUNC.HYBRID_NATIVE_LOGS);
        }
        return this;
    }


    onHybridDirectCall(data) {
        this._executeFunc(data);
    }

    _executeFunc(data) {
        let fn = this.getFuncName(data);

        if('function' === typeof this[fn]) {
            this[fn](data);
        }
    }

    getFuncName(data) {
        let fn = data[NATIVE_LOGS.CB_FN];

        return (undefined !== fn) ? fn : '';
    }

    writeToLog(data){

        const category = data[KEY_NAME.LOG_CATEGORY];
        const action = data[KEY_NAME.LOG_ACTION];
        const label = data[KEY_NAME.LOG_LABLE];
        const value = data[KEY_NAME.LOG_VALUE];

        this._sendElasticEvent(category, action, label, value);
    }

    _sendElasticEvent(category, action, label, value){

        const dataToSend  = {
            CGPEventCategory: category,
            CGPEventAction: action,
            CGPEventLabel: label,
            CGPEventValue: value
        };

        this._HybridService.serviceFactory.structuredLoggingService().getLogger(dataToSend).info();

    }
}

export default NativeLogs;
